define(
     'viewmodels/secured/explorer/details/tabs/actions/DocumentLinksAction',[
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings",
        "plugins/router"
     ],
    function (Action, dialogService, documentsService, i19n, router) {

        var DocumentLinksAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.documentlinks,
                    message: i19n.to.showdownloadlinkstoselecteddocuments,
                },
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-link", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documentInfo = action.context.checkedDocuments();

                setData(documentInfo);

                complete();

                router.navigate("actionsDocumentLinks");
            }

            function setData(context) {
                sessionStorage.removeItem("documentlinks");
                sessionStorage.setItem("documentlinks", JSON.stringify(context));
            }

            return _Action;

        })(Action);

        return DocumentLinksAction;
    });
